import React, { useCallback, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { useDispatch } from "react-redux";

import { config } from "../../config";
import { getUserDetail } from "../../utils/helper";
import { deleteMediaById } from "../../store/slices/albumSlice";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const MediaUpload = ({ album }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState(
    album.media.map((media) => {
      return {
        uid: media.id,
        name: `image-${media.id}`,
        status: "done",
        url: `${config.filesBaseUrl}/${media.filePath}`,
      };
    })
  );

  const dispatch = useDispatch();

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = useCallback(
    ({ fileList: newFileList, file }) => {
      if (file.status !== "done") {
        setFileList(newFileList);
      } else {
        const index = newFileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          const { id, filePath } = file.response;
          newFileList[index] = {
            uid: id,
            name: `image-${id}`,
            status: "done",
            url: `${config.filesBaseUrl}/${filePath}`,
          };

          setFileList(newFileList);
        }
      }
    },
    [setFileList]
  );

  const handleRemove = (item) => {
    dispatch(
      deleteMediaById({ albumId: album.id, mediaId: item.uid }, () => {})
    );
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  return (
    <>
      <Upload
        action={`${config.apiBaseUrl}/album/upload/${album.id}`}
        accept=".jpeg,.jpg,.png"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        headers={{ Authorization: `Bearer ${getUserDetail()?.accessToken}` }}
        multiple={true}
        onChange={handleChange}
        onRemove={handleRemove}
      >
        {fileList.length >= 50 ? null : uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
export default MediaUpload;
